import React from 'react';
import { BarChart3, LineChart, PieChart, TrendingUp } from 'lucide-react';
import Card from '../../Components/Ui/Card';
import TimeFilter from '../../Components/Ui/TimeFilter';
import { topProducts } from '../../Data/Dummydata';

const chartPlaceholder = (Icon, text) => (
  <div className="h-80 flex items-center justify-center bg-gray-50 rounded-lg">
    <div className="flex flex-col items-center text-gray-500">
      <Icon size={48} strokeWidth={1} />
      <p className="mt-2">{text}</p>
    </div>
  </div>
);

const Analytics = () => {
  const handleTimeFilterChange = (period) => {
    // Fetch data logic here
  };

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-2xl font-bold tertiary-text-color pl-5">Analytics</h2>
        <TimeFilter onChange={handleTimeFilterChange} />
      </div>

      {/* Revenue & Orders */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="Revenue Trends">
          {chartPlaceholder(LineChart, 'Revenue Trend Chart would go here')}
        </Card>
        <Card title="Orders Overview">
          {chartPlaceholder(BarChart3, 'Orders Bar Chart would go here')}
        </Card>
      </div>

      {/* Product Performance */}
      <Card title="Product Performance">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            {chartPlaceholder(BarChart3, 'Product Performance Chart would go here')}
          </div>
          <div>
            <h4 className="text-lg font-medium mb-4">Top Products</h4>
            <div className="space-y-4">
              {topProducts.map((product, idx) => (
                <div key={idx} className="bg-gray-50 p-3 rounded-lg">
                  <div className="flex justify-between items-center">
                    <p className="font-medium">{product.name}</p>
                    <p className="text-sm font-medium">{product.value} units</p>
                  </div>
                  <div className="mt-2 h-2 w-full bg-gray-200 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-primary rounded-full"
                      style={{ width: `${product.percentage}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Card>

      {/* Sales Channels & Retailer Performance */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="Sales Channels">
          {chartPlaceholder(PieChart, 'Sales Channel Distribution Chart would go here')}
        </Card>
        <Card title="Retailer Performance">
          {chartPlaceholder(TrendingUp, 'Retailer Performance Chart would go here')}
        </Card>
      </div>
    </div>
  );
};

export default Analytics;
